import { useState } from "react";
import AdminLayout from "../components/AdminLayout";

const allReports = [
  { id: 1, listingTitle: "UI/UX设计，移动端界面，交互原型", reporter: "用户A", reason: "虚假信息", detail: "联系方式无法接通，疑似虚假发布", time: "2024-01-15 14:30", status: "pending" },
  { id: 2, listingTitle: "抖音短视频代运营，月增粉10万+", reporter: "用户B", reason: "夸大宣传", detail: "承诺月增粉10万，实际效果远不达标", time: "2024-01-15 11:20", status: "pending" },
  { id: 3, listingTitle: "企业贷款咨询，快速放款，无抵押", reporter: "用户C", reason: "涉嫌诈骗", detail: "要求先付手续费，疑似金融诈骗", time: "2024-01-14 16:45", status: "processed" },
  { id: 4, listingTitle: "SEO优化，百度排名提升，效果保证", reporter: "用户D", reason: "重复发布", detail: "同一内容多次发布，刷屏行为", time: "2024-01-14 09:10", status: "dismissed" },
  { id: 5, listingTitle: "代写论文，各类学术文章，快速交付", reporter: "用户E", reason: "违规内容", detail: "代写论文属于违规服务", time: "2024-01-13 15:30", status: "processed" },
];

const statusMap: Record<string, { label: string; className: string }> = {
  pending: { label: "待处理", className: "bg-yellow-50 text-yellow-600" },
  processed: { label: "已处理", className: "bg-green-50 text-green-600" },
  dismissed: { label: "已驳回", className: "bg-gray-100 text-gray-500" },
};

export default function AdminReportsPage() {
  const [reports, setReports] = useState(allReports);
  const [filterStatus, setFilterStatus] = useState("all");

  const filtered = reports.filter(
    (r) => filterStatus === "all" || r.status === filterStatus
  );

  const handleProcess = (id: number, action: "processed" | "dismissed") => {
    setReports((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: action } : r))
    );
  };

  return (
    <AdminLayout>
      <div className="space-y-5">
        <div>
          <h1 className="text-xl font-bold text-gray-800">举报管理</h1>
          <p className="text-sm text-gray-500 mt-1">处理用户举报的违规信息</p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4">
          {[
            { label: "待处理", count: reports.filter((r) => r.status === "pending").length, color: "text-yellow-600", bg: "bg-yellow-50" },
            { label: "已处理", count: reports.filter((r) => r.status === "processed").length, color: "text-green-600", bg: "bg-green-50" },
            { label: "已驳回", count: reports.filter((r) => r.status === "dismissed").length, color: "text-gray-600", bg: "bg-gray-100" },
          ].map((s) => (
            <div key={s.label} className={`${s.bg} rounded-xl p-4`}>
              <div className={`text-2xl font-bold ${s.color}`}>{s.count}</div>
              <div className="text-sm text-gray-600 mt-1">{s.label}</div>
            </div>
          ))}
        </div>

        {/* Filter */}
        <div className="flex gap-2">
          {[
            { key: "all", label: "全部" },
            { key: "pending", label: "待处理" },
            { key: "processed", label: "已处理" },
            { key: "dismissed", label: "已驳回" },
          ].map((f) => (
            <button
              key={f.key}
              onClick={() => setFilterStatus(f.key)}
              className={`px-3 py-1.5 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                filterStatus === f.key
                  ? "bg-orange-500 text-white"
                  : "bg-white border border-gray-200 text-gray-600 hover:border-orange-400"
              }`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {/* List */}
        <div className="space-y-3">
          {filtered.map((report) => (
            <div key={report.id} className="bg-white rounded-xl border border-gray-100 p-5">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${statusMap[report.status]?.className}`}>
                      {statusMap[report.status]?.label}
                    </span>
                    <span className="text-xs text-gray-400">{report.time}</span>
                  </div>
                  <div className="text-sm font-medium text-gray-800 mb-1">
                    被举报信息：{report.listingTitle}
                  </div>
                  <div className="flex items-center gap-4 text-xs text-gray-500 mb-2">
                    <span>举报人：{report.reporter}</span>
                    <span>举报原因：<span className="text-red-500 font-medium">{report.reason}</span></span>
                  </div>
                  <div className="text-sm text-gray-600 bg-gray-50 rounded-lg px-3 py-2">
                    {report.detail}
                  </div>
                </div>
                {report.status === "pending" && (
                  <div className="flex flex-col gap-2 shrink-0">
                    <button
                      onClick={() => handleProcess(report.id, "processed")}
                      className="px-3 py-1.5 text-xs bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      下架信息
                    </button>
                    <button
                      onClick={() => handleProcess(report.id, "dismissed")}
                      className="px-3 py-1.5 text-xs border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      驳回举报
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))}
          {filtered.length === 0 && (
            <div className="bg-white rounded-xl border border-gray-100 py-16 text-center">
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                <i className="ri-checkbox-circle-line text-4xl text-gray-300" />
              </div>
              <p className="text-gray-400 text-sm">暂无举报记录</p>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
